export const BASE_URL = "https://tap-turtle-chat.vercel.app";
// export const BASE_URL = "http://localhost:3000";
export const EVENTS_ENDPOINT = `${BASE_URL}/api/events`;
export const RECORDING_ENDPOINT = `${BASE_URL}/api/recording`;
export const OBSERVABILITY_ENDPOINT = `${BASE_URL}/api/observability`;
export const EVENT_SEND_INTERVAL = 5000; // 5 seconds
export const MOUSE_MOVE_THROTTLE = 200; // 200 milliseconds
